<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <!--Special Part Starts-->
      <multiselect
        v-model="value"
        :clear-on-select="false"
        :close-on-select="!multiple"
        :disabled="disabled"
        :hide-selected="true"
        :loading="!ready"
        :multiple="multiple"
        :options="coreComplianceViolationReasons"
        :placeholder="placeholder.length > 0 ? placeholder : 'Type to search'"
        :preserve-search="true"
        :show-labels="showLabels"
        @input="update"
      >
        <template #noResult>
          <slot name="no-result">Oops! No result found.</slot>
        </template>
      </multiselect>
      <!--Special Part Ends-->

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

const coreComplianceViolationReasons = [
  "Appointment hygiene",
  "Documents expired",
  "Low conversion",
  "Unbanked cash",
];

export default {
  extends: BaseComponent,

  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      coreComplianceViolationReasons,
    };
  },

  methods: {
    update(object) {
      if (this.form) {
        if (object !== undefined && object !== null) {
          this.form[this.name] = object;
        }

        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", object);
    },
  },
};
</script>
